import * as mediaContentsApi from '@/api/mediaContents';

export default {
    namespaced: true,
    state: {
        progressIdx: 1,
        reloadIdx: 1,
        order: '',
        keyword: '',
        onlySelectable: false,
        filter: '',
        mediaContents: {
            links: {
                prev: null,
                next: null,
            },
            data: [],
            meta: {
                last_page: 0,
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            load: false,
        },
    },
    getters: {
        progressIdx: state => state.progressIdx,
        reloadIdx: state => state.reloadIdx,
        order: state => state.order,
        keyword: state => state.keyword,
        onlySelectable: state => state.onlySelectable,
        filter: state => state.filter,
        mediaContents: state => state.mediaContents,
        mediaContentsApi: (state, getters, rootState, rootGetters) => `/cms/${rootGetters.selectedServiceAccount.key}/programs/media_contents?`
            + `order=${getters.order}`
            + `&keyword=${encodeURI(getters.keyword)}`
            + `&page=${getters.mediaContents.meta.current_page}`
            + `&only_selectable=${getters.onlySelectable ? 1 : 0}`
            + `${getters.filter ? `&filter=${getters.filter}` : ''}`,
    },
    mutations: {
        setProgressIdx(state, payload) {
            state.progressIdx = payload;
        },
        setReloadIdx(state, payload) {
            state.reloadIdx = payload;
        },
        setOrder(state, payload) {
            state.order = payload;
        },
        setKeyword(state, payload) {
            state.keyword = payload;
            state.mediaContents.meta.current_page = 1;
        },
        setMediaContents(state, payload) {
            state.mediaContents = payload;
        },
        setMediaContentsLoad(state, payload) {
            state.mediaContents.load = payload;
        },
        setMediaContentsMetaCurrentPage(state, payload) {
            state.mediaContents.meta.current_page = payload;
        },
        setLoadMediaContentsInit(state) {
            state.progressIdx = 1;
            state.reloadIdx = 1;
            state.mediaContents.load = false;
        },
        setOnlySelectable(state, payload) {
            state.onlySelectable = payload;
        },
        setFilter(state, payload) {
            state.filter = payload;
        },
        setLoadMediaContentsResponse(state, payload) {
            state.mediaContents = payload;
            state.mediaContents.load = true;
            state.reloadIdx = 2;
        },
        setTranscodingProgressUpdate(state, payload) {
            payload.map((item) => {
                state.mediaContents.data.map((mediaContent) => {
                    if (mediaContent.id === item.media_content_id) {
                        // eslint-disable-next-line no-param-reassign
                        mediaContent.transcoding_percent = item.progress;
                    }
                    return mediaContent;
                });
                return item;
            });
        },
        finishUploadInit(state) {
            state.keyword = '';
            state.mediaContents.meta.current_page = 1;
        },
        clearReloadAndProgressIdx(state) {
            state.reloadIdx = 1;
            state.progressIdx = 1;
        },
        clearMediaContents(state) {
            state.progressIdx = 1;
            state.reloadIdx = 1;
            state.order = '';
            state.keyword = '';
            state.onlySelectable = false;
            state.filter = '';
            state.mediaContents = {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            };
        },
    },
    actions: {
        async loadMediaContents({ commit, dispatch }, mediaPageApi) {
            commit('setLoadMediaContentsInit');

            const response = await mediaContentsApi.loadMediaContents(mediaPageApi);

            commit('setLoadMediaContentsResponse', response.data);

            dispatch('getTranscodingProgress');
        },
        async getTranscodingProgress({ getters, commit }) {
            commit('setProgressIdx', 1);

            if (getters.mediaContents.data && getters.mediaContents.data.length > 0) {
                const selectedIds = getters.mediaContents.data
                    .filter(mediaContent => mediaContent.transcoding_state === 'assigned job')
                    .map(mediaContent => mediaContent.id);

                if (selectedIds.length > 0) {
                    const response = await mediaContentsApi.getTranscodingProgress(selectedIds);
                    const payload = response.data;

                    commit('setTranscodingProgressUpdate', payload);

                    if (payload.find(item => item.progress === 100)) {
                        commit('setReloadIdx', 2);
                    }

                    commit('setProgressIdx', 2);
                }
            }
        },
        doSearchByKeyword({ getters, commit, dispatch }, payload) {
            commit('setKeyword', payload);
            dispatch('loadMediaContents', getters.mediaContentsApi);
        },
        doSearch({ getters, dispatch }) {
            dispatch('loadMediaContents', getters.mediaContentsApi);
        },
        initializeSearch({ commit, dispatch }) {
            commit('setKeyword', '');
            commit('setMediaContentsMetaCurrentPage', 1);
            dispatch('doSearch');
        },
    },
};
